import { Stack } from "@mantine/core";
import { zodResolver } from "mantine-form-zod-resolver";
import { MapProvider } from "react-map-gl/maplibre";
import {
    createGeoLocationFormState,
    GeoLocationFormProvider,
    GeoLocationFormSchema,
    useGeoLocationForm,
} from "shared/components/message/compose/geoAudience/GeoAudienceContext";
import { GeoAudienceHeaderControls } from "shared/components/message/compose/geoAudience/GeoAudienceHeaderControls";
import { GeoAudienceMapCanvas } from "shared/components/message/compose/geoAudience/GeoAudienceMapCanvas";
import { GeoAudienceSummary } from "shared/components/message/compose/geoAudience/GeoAudienceSummary";

const mapId = "geo-audience-editor-map";

export const GeoAudienceEditor = () => {
    const form = useGeoLocationForm({
        initialValues: createGeoLocationFormState(),
        validate: zodResolver(GeoLocationFormSchema),
    });

    return (
        <GeoLocationFormProvider form={form}>
            <MapProvider>
                <Stack>
                    <GeoAudienceHeaderControls mapId={mapId} />
                    <GeoAudienceMapCanvas mapId={mapId} />
                    <GeoAudienceSummary />
                </Stack>
            </MapProvider>
        </GeoLocationFormProvider>
    );
};
